var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronUpRound = function SvgChevronUpRound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Chevron Up Round",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-473.000000, -345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevron---Up",
    transform: "translate(473.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.295,9 L6.705,13.59 C6.315,13.98 6.315,14.61 6.705,15 C7.095,15.39 7.725,15.39 8.115,15 L12.005,11.12 L15.885,15 C16.275,15.39 16.905,15.39 17.295,15 C17.685,14.61 17.685,13.98 17.295,13.59 L12.705,9 C12.325,8.61 11.685,8.61 11.295,9 Z",
    id: "icon/navigation/expand_less_24px"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronUpRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chevron-up-round.ddb1ca5b7f7c53a6a34a01d141f61775.svg";